import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./auth/AuthContext";
import { ThemeProvider } from "./theme/ThemeContext";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { installDomGuard } from "./lib/dom-guard";
import { captureAttribution } from "./lib/attribution";
import { App } from "./App";
import "./styles.css";

// Has to run before the first render so React only ever sees the guarded methods.
installDomGuard();
// Before the router rewrites the URL (redirects to /login drop the campaign parameters).
captureAttribution();

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 15_000, retry: 1, refetchOnWindowFocus: true } }
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <AuthProvider><BrowserRouter><App /></BrowserRouter></AuthProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>
);
